import AuthorizationCross from './authorization-cross'

export default AuthorizationCross
